import * as React from 'react';

export enum SectionedTableRowType {
    Single = 'single',
    GroupHeader = 'groupHeader',
    GroupItem = 'groupItem'
}

export interface ISectionedTableRowProps {
    label?: React.ReactNode;
    value?: React.ReactNode;
    rowType?: SectionedTableRowType;
}

export const SectionedTableRow: React.FC<ISectionedTableRowProps> = (props) => {
    const {
        label,
        value,
        rowType = SectionedTableRowType.Single
    } = props;

    return (
        <div className={`sectionedTableRow sectionedTableRow--${rowType}`}>
            <div className="sectionedTableRow__label">
                {label}
            </div>
            <div className="sectionedTableRow__value">
                {value}
            </div>
        </div>
    );
};

export default SectionedTableRow;